import { Field, FieldProps } from 'formik';
import { Info } from '@globalvisioninc/assets/icons';
import { UserRolesData } from 'types';
import { GVTypography } from 'components/lib';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { AUDIT_TRAIL_TOOLTIP, isUserPrimaryRoleSelected } from './auditTrailPermission';
import styles from './AuditTrailPermissionField.module.css';

type AuditTrailPermissionFieldProps = {
  roleId: string | undefined;
  roles: UserRolesData[];
  hidden?: boolean;
};

const AuditTrailPermissionField = ({ roleId, roles, hidden }: AuditTrailPermissionFieldProps) => {
  if (hidden || !isUserPrimaryRoleSelected(roleId, roles)) {
    return null;
  }

  return (
    <div className={styles.root}>
      <GVTypography variant="subtitle1">Additional permissions</GVTypography>
      <Field name="hasAuditTrail">
        {(fieldProps: FieldProps) => (
          <GVCheckbox
            name={fieldProps.field.name}
            checked={!!fieldProps.field.value}
            onChange={(_event, checked) => fieldProps.form.setFieldValue('hasAuditTrail', checked)}
            label={
              <span className={styles.label}>
                Audit trail
                <GVTooltip title={AUDIT_TRAIL_TOOLTIP}>
                  <Info />
                </GVTooltip>
              </span>
            }
            data-testid="audit_trail_permission"
          />
        )}
      </Field>
    </div>
  );
};

export default AuditTrailPermissionField;
